"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _NavItem = _interopRequireDefault(require("../utils/NavItem"));

var _sortNavConfig = _interopRequireDefault(require("../utils/sortNavConfig"));

var _storageSettings = require("../utils/storageSettings");

var _urlMap;

var BASE_API_URL = 'navconfig/v2/navconfig/';
var urlMap = (_urlMap = {}, (0, _defineProperty2.default)(_urlMap, _storageSettings.navConfigSettingsKey, 'settings'), (0, _defineProperty2.default)(_urlMap, _storageSettings.navConfigSettingsPreferencesKey, 'settings-preferences'), _urlMap);

function parse(config) {
  var sortedConfig = [];

  try {
    if (config && config.children && config.children.length > 0) {
      sortedConfig = (0, _sortNavConfig.default)(config.children).map(function (navItem) {
        return new _NavItem.default(null, navItem);
      });
    }
  } catch (e) {
    console.error(e);
  }

  return sortedConfig;
}

var cache = {};

var Config =
/*#__PURE__*/
function () {
  function Config() {
    (0, _classCallCheck2.default)(this, Config);
  }

  (0, _createClass2.default)(Config, null, [{
    key: "getLocal",
    value: function getLocal() {
      var navType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _storageSettings.navConfigSettingsKey;
      var storedConfig = (0, _storageSettings.getSessionSetting)(navType);
      return parse(storedConfig);
    }
  }, {
    key: "get",
    value: function get() {
      var navType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _storageSettings.navConfigSettingsKey;

      if (typeof cache[navType] === 'undefined') {
        var resource = urlMap[navType];
        cache[navType] = _apiClient.default.get(BASE_API_URL + resource).then(function (config) {
          var parsedConfig = parse(config);
          setTimeout(function () {
            (0, _storageSettings.setSessionSetting)(navType, config);
          }, 0);
          return parsedConfig;
        }).catch(function (onrejected) {
          if (onrejected.status === 404) {
            // We should be able to ignore
            return;
          } else {
            console.error(onrejected);
          }
        });
      }

      return cache[navType];
    }
  }]);
  return Config;
}();

exports.default = Config;